require('./brokerRightsBuyView.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const moment = require('moment');

// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ actions
const brokerRightsBuyActions = require('actions/brokerRightsBuy');
const productFileActions = require('actions/brokerGetProductFile');
const signaturePatternActions = require('actions/signaturePattern');
const BrokerSubscriptionActions = require('actions/brokerSubscription');
const preContractualMailActions = require('actions/preContractualMailInfo');
const profileActions = require('actions/profile');

// @ components
const Wizard = require('components/commons/wizard/wizard');
const WizardStep = require('components/commons/wizardStep/wizardStep');
const WizardError = require('components/commons/wizardError/wizardError');
const {
    BrokerRightsBuyStep1
} = require('components/broker/brokerRightsBuy/brokerRightsBuySteps/brokerRightsBuyStep1/brokerRightsBuyStep1');
const {
    BrokerRightsBuyStep2
} = require('components/broker/brokerRightsBuy/brokerRightsBuySteps/brokerRightsBuyStep2/brokerRightsBuyStep2');
const BrokerRightsBuySuccessStep = require('components/broker/brokerRightsBuy/brokerRightsBuySteps/brokerRightsBuySuccessStep/brokerRightsBuySuccessStep');
const BrokerRightsBuySidebar = require('components/broker/brokerRightsBuy/brokerRightsBuySidebar/brokerRightsBuySidebar');
const BrokerTruncatedBreadcrumb = require('components/broker/brokerTruncatedBreadcrumb/brokerTruncatedBreadcrumb');

// @helpers
const { getDocumentURL } = require('utilities/stringHelper');

// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    MYPROFILE_BROKER_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    API_ENTERPRISE_NUMBER,
    API_CENTER,
    HYPHEN,
    BROKER_BUY_SCREEN
} = require('constants/index');

class BrokerRightsBuyView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCancel = this.handleCancel.bind(this);
    }

    componentWillMount() {
        const { immBrokerRightsBuy, immCorporatesOperations, getProductFile, history } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsBuy.get('selectedCorporateOperationIndex');
        const isin = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex, 'isin'], false);
        const iso = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex, 'iso'], false);

        if (iso && isin) {
            getProductFile(isin, iso, BROKER_BUY_SCREEN);
        } else {
            history.push(BROKER_CORPORATE_OPERATIONS_URL);
        }
    }

    componentDidMount() {
        const { immCorporatesOperations, immBrokerRightsBuy, setSubscriptionInfo } = this.props;
        if (__CONTACT_CENTER__) {
            const { setWithValidateButton } = this.props;
            setWithValidateButton(false);
        }

        const immOperation = immCorporatesOperations.getIn([
            'selectedContract',
            'operations',
            immBrokerRightsBuy.get('selectedCorporateOperationIndex')
        ]);

        setSubscriptionInfo(
            immCorporatesOperations ? immCorporatesOperations.get('selectedContract').toJS() : {},
            immOperation ? immOperation.toJS() : {}
        );
    }

    componentWillUnmount() {
        const { resetProductFile, setWithValidateButton } = this.props;
        if (__CONTACT_CENTER__) {
            setWithValidateButton(true);
        }
        resetProductFile();
    }

    buildErroneous() {
        const title = formatText('broker-rightsBuyErrorTitle');
        const goBackButtonLabel = formatText('broker-rightsBuyGoBack').toUpperCase();
        const goBackButtonLink = MYPROFILE_BROKER_URL;
        const goBackButton = {
            label: goBackButtonLabel,
            url: goBackButtonLink
        };

        return (
            <div className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError errorMessage={title} mainButton={goBackButton}>
                        <FormattedText value="broker-rightsBuyErrorMessage" />
                    </WizardError>
                </div>
            </div>
        );
    }

    buildMifidBreadcrumb() {
        return [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('corporatesOperations-corporatesOperations'),
                url: BROKER_CORPORATE_OPERATIONS_URL
            }
        ];
    }

    buildSuccessful() {
        const { immBrokerRightsBuy, immCorporatesOperations } = this.props;

        return (
            <div className="row no-gutter">
                <div className="col-xs-12">
                    <BrokerRightsBuySuccessStep
                        immBrokerRightsBuy={immBrokerRightsBuy}
                        immCorporatesOperations={immCorporatesOperations}
                    />
                </div>
            </div>
        );
    }

    buildWizard() {
        const {
            finish,
            handleDisclaimerCheckboxChange,
            immBrokerRightsBuy,
            immCorporatesOperations,
            immProductFile,
            setVisibleStep,
            setWillCancel,
            validateStep,
            immPreContractualMail,
            immProfileFields,
            immBrokerSubscription,
            sendPreContractualMail,
            requestProfile,
            resetPrecontractualMail,
            setDocumentsRead,
            immFlagBasedFeatures,
            fetchExAntCostBuyRight
        } = this.props;
        const immSteps = immBrokerRightsBuy.get('steps');
        const firstStepLoading = immBrokerRightsBuy.getIn(['steps', FIRST_STEP, 'loading']);
        const secondStepLoading = immBrokerRightsBuy.getIn(['steps', SECOND_STEP, 'loading']);
        const actions = {
            validateStep,
            setVisibleStep,
            setWillCancel,
            finish: finish,
            cancel: this.handleCancel
        };
        const selectedCorporateOperationIndex = immBrokerRightsBuy.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const maxDate = moment(selectedCorporateOperation.get('closeDate'));
        const catalogData = immProductFile.get('catalogData');

        return (
            <Wizard
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={immBrokerRightsBuy.get('visibleStep')}
            >
                <WizardStep
                    position="first"
                    cancelButton={true}
                    isLoading={firstStepLoading}
                >
                    <BrokerRightsBuyStep1
                        immBrokerRightsBuy={immBrokerRightsBuy}
                        catalogData={catalogData}
                        maxDate={maxDate}
                    />
                </WizardStep>
                <WizardStep
                    position="last"
                    cancelButton={true}
                    addLoadingBehaviour={true}
                    isLoading={secondStepLoading}
                    immFinalButton="broker-rightsBuyFinishLabel"
                >
                    <BrokerRightsBuyStep2
                        immBrokerRightsBuy={immBrokerRightsBuy}
                        immCorporatesOperations={immCorporatesOperations}
                        handleDisclaimerCheckboxChange={handleDisclaimerCheckboxChange}
                        immPreContractualMail={immPreContractualMail}
                        immProfileFields={immProfileFields}
                        immBrokerSubscription={immBrokerSubscription}
                        requestProfile={requestProfile}
                        resetPrecontractualMail={resetPrecontractualMail}
                        sendPreContractualMail={sendPreContractualMail}
                        setDocumentsRead={setDocumentsRead}
                        immFlagBasedFeatures={immFlagBasedFeatures}
                        fetchExAntCostBuyRight={fetchExAntCostBuyRight}
                    />
                </WizardStep>
            </Wizard>
        );
    }

    findRights() {
        const {
            immMyInvestments,
            immBrokerRightsBuy,
            immCorporatesOperations,
        } = this.props;
        const selectedCorporateOperationIndex = immBrokerRightsBuy.get('selectedCorporateOperationIndex');
        const selectedCorporateOperation = immCorporatesOperations.getIn(['selectedContract', 'operations', selectedCorporateOperationIndex]);
        const contract = API_ENTERPRISE_NUMBER + API_CENTER + immCorporatesOperations.getIn(['selectedContract', 'cuenta', 'fullNumber']);
        const isin = selectedCorporateOperation.get('isin');
        const iso = selectedCorporateOperation.get('iso');
        const emitionCode = selectedCorporateOperation.get('codigoEmision');
        const valueCode = selectedCorporateOperation.get('codigoValorInterno');

        const contractWithRights = immMyInvestments
            .getIn(['contracts'])
            .find(immContract =>
                immContract.get('contract') === contract
            );

        const availableRights = contractWithRights ? contractWithRights
            .get('elements')
            .find(immElement =>
                immElement.get('emisionCode') === emitionCode &&
                immElement.get('isin') === isin &&
                immElement.get('iso') === iso &&
                immElement.get('valueCode') === valueCode
            ) : false;

        return availableRights ? availableRights.get('shares') : HYPHEN;
    }

    handleCancel() {
        this.props.history.push(BROKER_CORPORATE_OPERATIONS_URL);
    }

    render() {
        const {
            immBrokerRightsBuy,
            immCorporatesOperations,
            immProductFile,
            immVariables,
            immFlagBasedFeatures,
        } = this.props;
        const subtitleLeft = formatText('broker-rightsBuySubtitle');
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-brokerInvestments'),
                url: '/myprofile/broker'
            },
            {
                text: formatText('breadcrumb-brokerCorporateOperations'),
                url: BROKER_CORPORATE_OPERATIONS_URL
            },
            {
                text: formatText('breadcrumb-brokerRightsBuy')
            }
        ];

        let bodyContent;
        let commissionButton;

        if (immBrokerRightsBuy.get('submitSuccessful')) {
            bodyContent = this.buildSuccessful();
        } else if (immBrokerRightsBuy.get('submitError')) {
            bodyContent = this.buildErroneous();
        } else if (immBrokerRightsBuy.get('selectedCorporateOperationIndex') !== -1) {
            const wizard = this.buildWizard();
            const quotationValue = immProductFile.getIn(['productValue', 'amount'], 0);
            const quotation = immProductFile.get('productValue').merge({
                amount: quotationValue
            });
            const quotationDate = immProductFile.get('updatePriceDate');
            const quotationTime = immProductFile.get('updatePriceTime');
            const availableRights = this.findRights();
            const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));

            commissionButton = (
                <OKButton
                    modifier="primary"
                    to={fees_url}
                >
                    <FormattedText value="broker-rightsBuyCommissions" />
                </OKButton>
            );
            bodyContent = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {wizard}
                    </div>
                    <div className="col-xs-4" id="printable-wizard">
                        <BrokerRightsBuySidebar
                            immBrokerRightsBuy={immBrokerRightsBuy}
                            immCorporatesOperations={immCorporatesOperations}
                            quotation={quotation}
                            quotationDate={quotationDate}
                            quotationTime={quotationTime}
                            availableRights={availableRights}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                        />
                    </div>
                </div>
            );
        }

        return (
            <article className="broker-rights-buy">
                <OKCover size="medium" section="broker">
                    <BrokerTruncatedBreadcrumb
                        titleKey="broker-rightsBuyTitle"
                        breadcrumbConfig={mappingBreadcrumb}
                        subtitleLeft={subtitleLeft}
                    >
                        {commissionButton}
                    </BrokerTruncatedBreadcrumb>
                </OKCover>
                <section className="broker-rights-buy__body">
                    {bodyContent}
                </section>
            </article>
        );
    }
}

BrokerRightsBuyView.propTypes = {
    finish: PropTypes.func.isRequired,
    getProductFile: PropTypes.func.isRequired,
    handleDisclaimerCheckboxChange: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immBrokerRightsBuy: PropTypes.object.isRequired,
    immBrokerSubscription: PropTypes.object.isRequired,
    immCorporatesOperations: PropTypes.object.isRequired,
    immMyInvestments: PropTypes.object.isRequired,
    immPreContractualMail: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetPrecontractualMail: PropTypes.func.isRequired,
    resetProductFile: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
    setWillCancel: PropTypes.func.isRequired,
    setSubscriptionInfo: PropTypes.func.isRequired,
    validateStep: PropTypes.func.isRequired,
    setWithValidateButton: PropTypes.func,
    setDocumentsRead: PropTypes.func.isRequired,
    immVariables: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    fetchExAntCostBuyRight: PropTypes.func,
};

module.exports.constructor = BrokerRightsBuyView;
module.exports.BrokerRightsBuyView = connect(
    state => ({
        immBrokerRightsBuy: state.brokerRightsBuy,
        immCorporatesOperations: state.brokerCorporatesOperations,
        immMyInvestments: state.brokerMyInvestments,
        immPreContractualMail: state.preContractualMail,
        immProductFile: state.brokerProductFile,
        immProfileFields: state.profile,
        immBrokerSubscription: state.brokerSubscription,
        immVariables: state.globalVariables,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        finish: brokerRightsBuyActions.finish,
        getProductFile: productFileActions.getProductFileWithCatalogData,
        handleDisclaimerCheckboxChange: brokerRightsBuyActions.toggleDisclaimerCheckbox,
        requestProfile: profileActions.requestProfile,
        reset: brokerRightsBuyActions.reset,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetProductFile: productFileActions.reset,
        sendPreContractualMail: preContractualMailActions.sendBrokerPreContractualMail,
        setVisibleStep: brokerRightsBuyActions.setVisibleStep,
        setWillCancel: brokerRightsBuyActions.setWillCancel,
        setSubscriptionInfo: BrokerSubscriptionActions.setSubscriptionInfo,
        validateStep: brokerRightsBuyActions.validateStep,
        setWithValidateButton: signaturePatternActions.setWithValidateButton,
        setDocumentsRead: brokerRightsBuyActions.setDocumentsRead,
        fetchExAntCostBuyRight: brokerRightsBuyActions.getExAntCostBuyRight
    }
)(withRouter(BrokerRightsBuyView));
